import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import {connect} from 'react-redux';
import _ from 'lodash';

import {fetchUserToken, fetchShoppingCartItems} from "../../redux/actions";
import CartListItem from './cartListItem';
import './cartListPanel.css';

class CartListPanel extends Component {
  constructor(props) {
    super(props);
		this.state = {
      loading: true
    };
  }

  componentDidMount(){
    if(_.isEmpty(this.props.userToken)) {
      this.props.fetchUserToken().then(()=>{
        this.props.fetchShoppingCartItems(this.props.userToken);
      });
    } else {
      this.props.fetchShoppingCartItems(this.props.userToken);
    }

    this.setState({
      loading: false
    });
  }

  render(){
		if(this.state.loading){
			return <div>Loading...</div>;
		}

    let shoppingCartItems = this.props.shoppingCartItems;
    if (shoppingCartItems.length > 0) {
      localStorage.setItem('shoppingCartItems', JSON.stringify(shoppingCartItems));
    }

    if(_.isString(shoppingCartItems) || _.isEmpty(shoppingCartItems)){
      return (
        <div>
          <Row className="show-grid">
            <Col id="cardListCol" md={7} >
              <Link to="/category/all" className="CartListCaption">
                <i className="fa fa-home"></i> Return To Store
              </Link>
              <p> Your shopping cart is still empty. </p>
            </Col>
            <Col id="cardListCol2" md={5} >
              <div className="PayPanel">
                <div className="CartListCaption">Cart Totals</div>
                <table id="CartListPrice">
                  <tbody>
                    <tr>
                      <td>Sub-total</td>
                      <td id="CartListPriceNum">$0</td>
                    </tr>
                  </tbody>
                </table>
                <br/>
                
                  <button type="button" className="btn btn-success" disabled>CHECKOUT</button>
                
                <Link to="/category/all">
                  <button type="button" className="btn btn-primary">CONTINUE SHOPPING</button>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else {
      let shoppingcartTotalPrice = 0;
      return(
        <div>
          <Row className="show-grid">
            <Col id="cardListCol" md={7}>
               <Link to="/category/all" className="CartListCaption">
                <i className="fa fa-home"></i> Return To Store
              </Link>
              <table>
                <tbody>
                {shoppingCartItems.map((cartitem, index)=>{
                  let orderedObject = cartitem.order;
                  let orderedColor = Object.keys(orderedObject)[0];
                  let orderedNum = orderedObject[orderedColor];
                  let cartitemUnitPrice = cartitem.totalPrice
                  let totalPrice = cartitemUnitPrice ;
                  shoppingcartTotalPrice += totalPrice;
                  return (<tr key={index}>
                            <td>
                              <CartListItem
                                flowerId={cartitem.product.id}
                                name={cartitem.product.name}
                                imgURL={cartitem.product.imageURL}
                                price={cartitem.product.wholePrice}
                                totalprice={cartitem.totalPrice}
                                color={orderedColor}
                                qty={orderedNum}
                                rerenderPanel = {this.rerenderPanel} />
                            </td>
                          </tr>)})
                  }
                </tbody>
              </table>
            </Col>
            <Col id="cardListCol2" md={5} >
              <div className="PayPanel">
                <div className="CartListCaption">Cart Totals</div>
                <table id="CartListPrice">
                  <tbody>
                    <tr>
                      <td>Sub-total</td>
                      <td id="CartListPriceNum">${shoppingcartTotalPrice}</td>
                    </tr>
                  </tbody>
                </table>
                <br/>
                <Link to="/order/info">
                  <button type="button" className="btn btn-success">CHECKOUT</button>
                </Link>
                <Link to="/category/all">
                  <button type="button" className="btn btn-primary">CONTINUE SHOPPING</button>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      );
    }
  }
}

function mapStateToProps(state){
  return({
    shoppingCartItems: state.shoppingCartItems,
    userToken: state.userToken
  });
}

export default connect(mapStateToProps, {fetchUserToken, fetchShoppingCartItems})(CartListPanel);



// WEBPACK FOOTER //
// ./src/components/orderPage1/cartListPanel.js